import React from "react";

const ContactsAndItemsIcon = () => {
  return (
    <div>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M23 14C21.9 14 21 14.9 21 16H20V7L7 12V25H25V16C25 14.9 24.1 14 23 14ZM9 13.37L18 9.91V16H13V23H9V13.37ZM23 23H20V20H18V23H15V18H23V23Z" />
      </svg>
    </div>
  );
};

export default ContactsAndItemsIcon;
